import {
  faDashboard,
  faChartLine,
  faSheetPlastic,
  faFileInvoice,
} from '@fortawesome/free-solid-svg-icons'

export const sectionsFaturamento = [
  {
    title: 'Dashboard',
    icon: faDashboard,
    to: '/dashboard',
    requiredPermission: 'Listar dashboard de aluguel',
  },
  {
    title: 'Faturamento',
    icon: faSheetPlastic,
    items: [
      {
        name: 'Faturamento',
        icon: faChartLine,
        to: `/faturamento/faturar`,
        requiredPermission: 'Listar faturamentos',
      },
      {
        name: 'Romaneios',
        icon: faFileInvoice,
        to: `/faturamento/romaneios`,
        requiredPermission: 'Ver Carregamentos',
      },
    ],
  },
]
